import { Faq1CardSchema, Faq2CardSchema, type Faq1Card, type Faq2Card } from "@stackje/common/config";
import { ValidationError, getStringFromFormData, getOptionalStringFromFormData } from "./validation";

export function parseFaqCard(formData: FormData): Faq1Card | Faq2Card {
  // Parse FAQs from indexed form fields
  const faqs = [];
  let i = 0;
  while (formData.has(`faqQuestion${i}`)) {
    faqs.push({
      question: getStringFromFormData(formData, `faqQuestion${i}`),
      answer: getStringFromFormData(formData, `faqAnswer${i}`),
    });
    i++;
  }

  const type = formData.get("type") as "faq1" | "faq2";

  const cardData = {
    type,
    title: getOptionalStringFromFormData(formData, "title"),
    description: getOptionalStringFromFormData(formData, "description"),
    faqs,
    expandAll: formData.get("expandAll") === "true",
    colors: JSON.parse(formData.get("colors") as string),
  };

  try {
    if (type === "faq2") {
      return Faq2CardSchema.parse(cardData);
    }
    return Faq1CardSchema.parse(cardData);
  } catch (error) {
    if (error instanceof Error) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      throw new ValidationError(error as any);
    }
    throw error;
  }
}
